import * as React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import { ReactComponent as IconEdit } from "../../../assets/icons/icon_edit.svg";

const StyledRow = styled(Row)`
  padding: 11px 21px;
  border: 1px solid #e8e8e8;
  height: 100% !important;
`;

const StyledEditIcon = styled(IconEdit)`
  svg {
    width: 100%;
  }
  :hover {
    span {
      color: #386ee8;
    }
    path,
    circle,
    rect,
    polygon,
    polyline,
    line {
      stroke: #386ee8;
    }
  }
`;

const InvisibleButton = styled.button`
  border: none !important;
  outline: none !important;
  padding: 1px;
  margin: 2px;
  background-color: transparent;
  width: 29px;
  height: 29px;
  cursor: pointer;
`;

const EntryHeadline = styled.span`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

const SubTitle = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
  display: inline-block;
`;

type Props = {
  title: string;
  subTitle?: string | Date | boolean;
  style?: object;
  onEditClick?: () => void;
};

export const SummaryEntry: React.FC<Props> = props => {
  return (
    <StyledRow style={props.style}>
      <Col span={24}>
        <Row type="flex" style={{ justifyContent: "space-between" }}>
          <Col>
            <EntryHeadline>{props.title}</EntryHeadline>
            {!!props.subTitle && (
              <>
                <br />
                <SubTitle>{props.subTitle}</SubTitle>
              </>
            )}
          </Col>
          <Col>
            {!!props.onEditClick && (
              <InvisibleButton onClick={props.onEditClick}>
                <StyledEditIcon />
              </InvisibleButton>
            )}
          </Col>
        </Row>
        <Col span={24}>
          <Row>{props.children}</Row>
        </Col>
      </Col>
    </StyledRow>
  );
};
